var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwiggy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11154_89179)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.11084,
    y: -0.294922,
    width: 53.7778,
    height: 53.7778,
    rx: 1.07556,
    fill: "#FE5005"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11154_89179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 54,
    height: 55
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.109131,
    y: -0.294922,
    width: 53.7778,
    height: 53.7778,
    rx: 1.07556,
    fill: "#FE5005"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11154_89179)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1624 19.996V14.1924C29.1615 14.0114 29.0878 13.8381 28.9573 13.7102C28.8269 13.5824 28.6502 13.5103 28.4659 13.5097C28.2818 13.5106 28.1055 13.5828 27.9753 13.7107C27.845 13.8385 27.7715 14.0116 27.7706 14.1924V21.0102C27.7706 21.3964 28.0903 21.7045 28.4778 21.7045H29.1565C39.0222 21.7045 40.0479 22.2087 39.4322 24.2533C39.4037 24.3537 39.3692 24.4494 39.3348 24.5568L39.3181 24.6174C36.7269 32.286 29.7211 41.8824 27.6505 44.6273C27.583 44.7173 27.4949 44.7904 27.3933 44.8409C27.2917 44.8913 27.1795 44.9175 27.0657 44.9175C26.9519 44.9175 26.8396 44.8913 26.7381 44.8409C26.6365 44.7904 26.5484 44.7173 26.4809 44.6273C25.2316 42.9689 22.1733 38.8015 19.3836 34.0727C19.1946 33.6409 19.103 32.6338 22.2006 32.6338H25.99C26.2016 32.6338 26.3727 32.8018 26.3727 33.0084V36.0111C26.3727 36.3694 26.6402 36.6997 27.0051 36.7289C27.1068 36.7373 27.2092 36.7236 27.305 36.6887C27.4007 36.6538 27.4875 36.5985 27.559 36.527C27.6251 36.4648 27.6775 36.3899 27.7129 36.307C27.7483 36.2241 27.7659 36.1349 27.7646 36.045V31.9721C27.7634 31.7853 27.6872 31.6065 27.5525 31.4746C27.4179 31.3426 27.2357 31.2681 27.0455 31.2672H19.3895C18.0535 31.2672 17.244 30.1468 16.7127 29.1268C15.0474 25.6981 13.8552 22.3149 13.8552 19.6482C13.8552 12.8211 19.4002 6.67557 27.0574 6.67557C33.8754 6.67557 39.0388 11.5421 40.0884 17.4309C40.0943 17.4811 40.1335 17.7051 40.1395 17.7495C40.4129 20.6402 32.7343 20.3099 29.5048 20.3263C29.4597 20.3266 29.4151 20.3181 29.3734 20.3013C29.3317 20.2846 29.2939 20.2598 29.262 20.2285C29.2302 20.1973 29.2049 20.1601 29.1879 20.1192C29.1708 20.0782 29.1621 20.0344 29.1624 19.9902V19.996Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11154_89179"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.111084,
    y: 0.111115,
    width: 53.7778,
    height: 53.7778,
    rx: 4.88889,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiggy);
export default __webpack_public_path__ + "static/media/swiggy.f1be4130f35e1292d69be8273b401484.svg";
export { ForwardRef as ReactComponent };